import { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import { getBusinessPartnerModel } from "../../BusinessPartner/Infrastructure/BusinessPartner.reducer";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import FlatButton from "../../DesignSystem/FlatButton";
import TabPanel from "../../DesignSystem/TabPanel";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import DatePicker from "../../DesignSystem/DatePicker";
import CommissionsTable from "../../DesignSystem/CommissionsTable";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { GetListCommissions } from "../Infrastructure/Business.presenter";
import StatusAccount from "../../components/accountstatus";
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const commissionContent = {
  background: "white",
  width: "100%",
  height: "auto",
  maxWidth: "1164px",
  minWidth: "1164px",
  borderRadius: "5px",
  margin: { sm: "0px", md: "auto" },
  marginTop: { md: "20px", lg: "20px" },
  minHeight: "913px",
  padding: { xs: "60px 5px", sm: "40px 20px", md: "36px 40px 59px" },
};

const typeTabs = {
  fontWeight: 700,
  fontFamily: "Montserrat",
  color: "#000",
  textTransform: "none",
};

const btnExport = {
  height: "32px",
  color: "#EA5B13",
  fontWeight: 700,
  border: "2px solid #EA5B13",
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
}));

export default function BusinessCommissions() {
  let opp = new StatusAccount();
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const businessPartner = useSelector(getBusinessPartnerModel);
  const [commissions, setCommissions] = useState({});
  const [commissionsR, setCommissionsR] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (businessPartner) {
      fetchCommissionsData(businessPartner.zone);
    }
  }, [businessPartner]);

  

  async function fetchCommissionsData(zone) {
    try {
      const info = await GetListCommissions(zone);
      var arreCalculate = [];
      arreCalculate=opp.getCalculate(info);
      setCommissions(arreCalculate);
      setCommissionsR(true);
    } catch (error) {
      console.log("Error al obtener los datos", error);
    }
  }

  return (
    <Box sx={commissionContent}>
      <Box className={classes.headerContainer}>
       {/*  <DatePicker title={"Período (30 días)"} widthDate={"200px"} /> */}
        <ExcelFile
          element={
            <FlatButton
            title={"Exportar"}
            typeButton="button"
            variant={"outlined"}
            icon={<FileUploadOutlinedIcon />}
            widthBtn="167px"
            customStyles={btnExport}
          />
          }
          filename={"GananciasTuZona"}
        >
          <ExcelSheet data={commissions} name="InformationComercial">
            <ExcelColumn label="Negocios" value="shop_name" />
            <ExcelColumn label="#Ordenes" value="orderslength" />
            <ExcelColumn label="Envios Tienda" value="comSendShops" />
            <ExcelColumn label="Envios Cliente" value="comSendClients" />
            <ExcelColumn label="Propinas" value="amountPropine" />
            <ExcelColumn label="Comisión Niku 50%" value="comisionNks" />
            <ExcelColumn label="Ganancias" value="total" />
          
          </ExcelSheet>
        </ExcelFile>
    
      </Box>

      <Divider sx={{ marginTop: "20px", marginBottom: "20px" }} />

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          textColor="secondary"
          indicatorColor="secondary"
          value={value}
          onChange={handleChange}
        >
          <Tab sx={typeTabs} label="Comisión por envío" {...a11yProps(0)} />
          <Tab sx={typeTabs} label="Comisión directa" {...a11yProps(1)} />
        </Tabs>
      </Box>

      <div>
        <TabPanel value={value} index={0}>
          {commissionsR && <CommissionsTable data={commissions} />}
        </TabPanel>
        <TabPanel value={value} index={1}>
          <h3>Sin registros</h3>
        </TabPanel>
      </div>
    </Box>
  );
}
